import { RouteParameters } from "./route-parameters";

const PERFORMANCE_ROUTING = {
  CONFIGURE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/performance/configure`,
  COOL_STUFF: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/performance/cool-stuff`,
  CREATE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/performance/create`,
  ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/performance`,
  VIEW: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/performance/view`,
} as const;

const PERFORMANCE_ROUTES = [
  PERFORMANCE_ROUTING.ROOT,
  PERFORMANCE_ROUTING.VIEW,
  PERFORMANCE_ROUTING.CREATE,
  PERFORMANCE_ROUTING.CONFIGURE,
  PERFORMANCE_ROUTING.COOL_STUFF,
] as const;

export { PERFORMANCE_ROUTES, PERFORMANCE_ROUTING };
